import { Pipe, PipeTransform } from '@angular/core';
import { SinglePackagingModel } from '../../models/single-packaging.model';

@Pipe({
  name: 'singlePackagingFilter',
})
export class SinglePackagingFilterPipe implements PipeTransform {
  transform(singlePackagings: SinglePackagingModel[], overpackId: string): SinglePackagingModel[] {
    return singlePackagings.filter(item => item.ParentId === overpackId);
  }
}
